import microuniversoApi from "app/api/microuniversoApi";
import { InsumoOrdemProducao } from "app/types/OrdemProducao";
import { tratamentoErroPadrao } from "app/use-cases";
import { Dict } from "app/utils/Dict";
import globalMU from "globalMU";
import React, { useEffect, useRef, useState } from "react";
import { Breadcrumb2Container } from "../../breadcrumb2/Breadcrumb2Container";
import { renderizarComponentReact } from "../../renderizarOuRemoverComponentReact";
import { InclusaoInsumo } from "./InclusaoInsumo";
import * as R from "ramda";


type InclusaoInsumoContainerProps = {
    onVoltar: () => void
    onRemover: () => boolean
    passos: Dict<string, () => void>;
    filtros: {
        codigoProduto: string
        filial: string
        insumosJaInformados: InsumoOrdemProducao[],
        quantidade : number
    }
    onInserirInsumos:(insumos: InsumoOrdemProducao[]) => void
}

export const InclusaoInsumoContainer = (props: InclusaoInsumoContainerProps) => {

    const [insumos, setInumos] = useState<InsumoOrdemProducao[]>([])
    const [insumosSelecionados, setInsumosSelecionados] = useState<InsumoOrdemProducao[]>([])
    const [selecionadoTodos, setSelecionadoTodos] = useState<boolean>(false)

    const passosInterno = useRef<Dict<string, () => void>>(new Dict())

    const onRenderizarInsumoContainer = () => renderizarComponentReact(
        <InclusaoInsumoContainer {...props} />, "ordem-de-producao-region", true
    )

    const onObterDadosInclusao = async () => {
        try {
            globalMU.blockUI();

            const resposta = await microuniversoApi.OrdemProducao.ConsultarInsumosInclusao({
                CodigoProduto: props.filtros?.codigoProduto,
                ListaProdutosJaInformados: props.filtros?.insumosJaInformados?.map(x => x.CodigoProdutoInsumo)?.toString(),
                Filial: props.filtros?.filial,
                Quantidade: props.filtros?.quantidade
            })

            if (!("HasErrors" in resposta)) {
                setInumos(resposta)
            } else{
                setInumos([]);
                onVoltar()
            }
        }
        catch (e) {
            tratamentoErroPadrao(e);
            onVoltar()
        }
        finally {
            globalMU.unblockUI();
        }
    }

    const onAlterarQuantidade = (quantidade: number, codigoProduto: string, quantidadeOriginal: number) => {
        const novoDadosInsumoOrdemProducao = [...insumos];

        const item = insumos.find((x) => x.CodigoProdutoInsumo == codigoProduto)
        const itemIndex = insumos.findIndex((x) => x.CodigoProdutoInsumo == codigoProduto)
        const quantidadeMinima = item.QuantidadeMinima * props.filtros?.quantidade;
        const quantidadeMaxima = item.QuantidadeMaxima * props.filtros?.quantidade;

        if ((quantidade < quantidadeMinima) || (quantidade > quantidadeMaxima)) {

            globalMU.showWarnMessage(`Informe uma quantidade entre a quantidade mínima: ${globalMU.formatarValorNumerico(quantidadeMinima, 3, false)} e quantidade máxima: ${globalMU.formatarValorNumerico(quantidadeMaxima, 3, false)}`)
            item.QuantidadeFinal = quantidadeOriginal;
            novoDadosInsumoOrdemProducao[itemIndex] = item;
            setInumos(novoDadosInsumoOrdemProducao)

        } else {
            item.QuantidadeFinal = quantidade;
            novoDadosInsumoOrdemProducao[itemIndex] = item
            setInumos(novoDadosInsumoOrdemProducao)
        }
    }

    const onSelecionarInsumo = (insumo: InsumoOrdemProducao) => {
        if (insumosSelecionados?.find((item) => item.CodigoProdutoInsumo == insumo.CodigoProdutoInsumo) != undefined) {
            setInsumosSelecionados(
                R.filter((c) => c.CodigoProdutoInsumo != insumo.CodigoProdutoInsumo, insumosSelecionados)
            );
            setInsumosSelecionados(
                R.filter((c) => c.CodigoProdutoInsumo != insumo.CodigoProdutoInsumo, insumosSelecionados)
            );
        } else {
            setInsumosSelecionados(insumosSelecionados.concat(insumo));
            setInsumosSelecionados(insumosSelecionados.concat(insumo));
        }
    }

    const onSelecionaTodos = () => {
        const todosSelecionados = insumosSelecionados.length === insumos.length;
    
        if (todosSelecionados) {
            setInsumosSelecionados([]);
            setSelecionadoTodos(false)
        } else {
            setInsumosSelecionados(insumos);
            setSelecionadoTodos(true)
        }
    }

    const onPassoSelecionado = (passo: string) => {
        props.onRemover()
        passosInterno.current.get(passo)()
    }

    const onVoltar = () => {
        props.onRemover()
        props.onVoltar()
    }

    useEffect(() => {
        passosInterno.current.set("Inclusão de Insumos", () => onRenderizarInsumoContainer())
        onObterDadosInclusao()
    }, [])


    return (
        <>

            <Breadcrumb2Container
                passos={passosInterno?.current?.keysToList()}
                exibirBotaoLimpar={false}
                exibirBotaoVoltar={true}
                id="InclusaoInsumoContainer"
                onPassoSelecionado={onPassoSelecionado}
                onBotaoVoltarClicado={onVoltar}
            />

            <InclusaoInsumo
                selecionarTodos={selecionadoTodos}
                listaQuantidade={insumos?.map((x) => ({
                    codigo: x.CodigoProdutoInsumo,
                    quantidade: x.QuantidadeFinal ?? x.QuantidadeFormula,
                }))}
                insumosSelecionados={insumosSelecionados}
                insumos={insumos}
                onAlterarQuantidade={onAlterarQuantidade}
                onSelecionaTodos={onSelecionaTodos}
                onSelecionarInsumo={onSelecionarInsumo}
                onOk={() => props.onInserirInsumos(insumosSelecionados)}
            />
        </>
    )
}
